import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Trash2, Copy } from "lucide-react";
import { api, mediaUrl, formatApiErrorDetail } from "../../lib/api";
import { btnCls } from "./crud";

export default function MediaAdmin() {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = () => api.get("/admin/media").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Archivo subido"); load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setUploading(false); e.target.value = ""; }
  };

  const remove = async (id) => {
    if (!window.confirm("¿Eliminar archivo?")) return;
    await api.delete(`/admin/media/${id}`);
    toast.success("Eliminado"); load();
  };

  const copy = (url) => { navigator.clipboard.writeText(url); toast.success("URL copiada"); };

  return (
    <div data-testid="media-admin">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-display text-xl font-light">Biblioteca Multimedia</h1>
        <button onClick={() => fileRef.current?.click()} disabled={uploading} className={btnCls} data-testid="media-upload-btn">
          <Upload size={14} /> {uploading ? "SUBIENDO..." : "SUBIR ARCHIVO"}
        </button>
        <input ref={fileRef} type="file" className="hidden" onChange={upload} accept=".jpg,.jpeg,.png,.webp,.gif,.svg,.pdf,.mp4" data-testid="media-file-input" />
      </div>
      <p className="font-mono-tech text-[10px] tracking-widest text-slate-400 mb-6">REPOSITORIO DE IMÁGENES CON DERECHOS DE AUTOR DEL ECOSISTEMA · CÓDIGO ÚNICO NC-IMG · © NATUR COMMODITIES, S.L. · ALMACENAMIENTO DE OBJETOS EN LA NUBE</p>
      {items.length === 0 && <p className="text-xs text-slate-400 border border-slate-200 rounded-lg bg-white p-6">Biblioteca vacía.</p>}
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
        {items.map((m) => (
          <div key={m._id} className="hud-border bg-white p-2" data-testid={`media-item-${m._id}`}>
            {m.content_type?.startsWith("image") ? (
              <img src={mediaUrl(m.url)} alt={m.filename} className="w-full h-24 object-cover" />
            ) : (
              <div className="h-24 flex items-center justify-center text-[10px] text-slate-500 break-all p-1">{m.filename}</div>
            )}
            <div className="mt-2 text-[10px] text-slate-500 truncate">{m.filename}</div>
            {m.code && <div className="font-mono-tech text-[9px] text-[#4587B8] mt-0.5" title={m.copyright}>{m.code} · ©</div>}
            <div className="flex justify-between mt-2">
              <button onClick={() => copy(m.url)} className="text-slate-500 hover:text-[#5698C7] transition-colors duration-200" data-testid={`media-copy-${m._id}`}><Copy size={12} /></button>
              <button onClick={() => remove(m._id)} className="text-slate-500 hover:text-red-600 transition-colors duration-200" data-testid={`media-delete-${m._id}`}><Trash2 size={12} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
